import Country from "./Country";
import Manager from "./Manager";
import Note from "./Note";
import Permission from "./Permission";
import Revision from "./Revision";
import Sponsor from "./Sponsor";
import User from "./User";

export interface MemberInterface {
  id: number;
  is_admin: boolean;
  user: User | null;
  user_id: string;
  nickname: string;
  first_name: string;
  last_name: string;
  sendbird_token: string;
  profile_image: string;
  profile_image_tiny: string;
  action_image: string;
  action_image_tiny: string;
  created_at: string;
  updated_at: string;
  approved_at: string;
  rejected_at: string;
  closed_at: string;
  blocked_at: string;
  deleted_at: string;
  last_seen: string;
  api_token: string;
  registration_stage_id: number;
  permissions: Permission[];
  nationality: Country | null;
  represents: Country | null;
  manager: Manager | null;
  sponsors: Sponsor | null;
  revisions: Revision[];
  notes: Note[];
  unread_files: number;
  profile_thumbnail: string;
  action_thumbnail: string;
}

export enum MemberStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
  BLOCKED = "blocked",
}

export interface MemberType {
  can_create_chats_with: string;
  name: string;
}

export default class Member implements MemberInterface {
  id: number = 0;
  is_admin: boolean = false;
  user: User | null = null;
  user_id: string = "";
  nickname: string = "";
  first_name: string = "";
  last_name: string = "";
  sendbird_token: string = "";
  profile_image: string = "";
  profile_image_tiny: string = "";
  action_image: string = "";
  action_image_tiny: string = "";
  created_at: string = "";
  updated_at: string = "";
  approved_at: string = "";
  rejected_at: string = "";
  closed_at: string = "";
  blocked_at: string = "";
  deleted_at: string = "";
  last_seen: string = "";
  api_token: string = "";
  registration_stage_id: number = 0;
  nationality: Country | null = null;
  represents: Country | null = null;
  manager: Manager | null = null;
  sponsors: Sponsor | null = null;
  revisions: Revision[] = [];
  notes: Note[] = [];
  permissions: Permission[] = [];
  status: MemberStatus = MemberStatus.PENDING;
  unread_files: number = 0;
  profile_thumbnail: string = "";
  action_thumbnail: string = "";
  member_type: MemberType | null = null;

  can(action: string): boolean {
    return this.permissions.filter((permission: Permission) => permission.name === action).length > 0;
  }

  static fromArray(data: any): Member {
    const member = new Member();
    Object.assign(member, data);
    return member;
  }
}
